import { categoryValidation } from '@/modules/master/property/category/category.validation';
import { subCategoryValidation } from './subCategory/subCategory.validation';
import { propertyUsageValidation } from './propertyUsage/propertyUsage.validation';
import { propertySizeValidation } from './propertySize/propertySize.validation';
import { configurationValidation } from './configuration/configuration.validation';

export const commonValidation = {
  category: categoryValidation,
  subCategory: subCategoryValidation,
  propertyUsage: propertyUsageValidation,
  propertySize: propertySizeValidation,
  configuration: configurationValidation,
};
